module.exports = __webpack_public_path__ + "img/TractionLinux2.51f7490a.png";